module.exports = __webpack_public_path__ + "static/media/increase.98a8237c.svg";